import { render, staticRenderFns } from "./SearchLicenses.vue?vue&type=template&id=6f5bb7d6&scoped=true"
import script from "./SearchLicenses.vue?vue&type=script&lang=js"
export * from "./SearchLicenses.vue?vue&type=script&lang=js"
import style0 from "./SearchLicenses.vue?vue&type=style&index=0&id=6f5bb7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5bb7d6",
  null
  
)

export default component.exports